@for (widget of data?.widgets; track widget; let i = $index) {
  <span [matTooltip]="!hasValidStep(widget) ? ('campaign.publish-validation.no-valid-steps' | translate) : ''" style="display: block">
    <button mat-menu-item [disabled]="!hasValidStep(widget)" (click)="previewWidget.emit(widget)">
      @if (data.type !== CampaignTypes.ABTesting && data.campaign?.type !== CampaignTypes.ABTesting) {
        <span>{{ widget.name ? widget.name : "Variant" + " " + (i + 1) }}</span>
      }
      @if (data.type === CampaignTypes.ABTesting || data.campaign?.type === CampaignTypes.ABTesting) {
        @if (i === 0) {
          <span>{{ "campaign.ab-test.control" | translate }}</span>
        }
        @if (i === 1) {
          <span>{{ "campaign.ab-test.challenger" | translate }}</span>
        }
      }
    </button>
  </span>
}
